import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ButtonOverlay from './ButtonOverlay';
import FitOnPage from './FitOnPage';
import SameWidth from './SameWidth';
import ScrollPosition from './ScrollPosition';
import StickInSvg from './StickInSvg';
import StickNodeWidth from './StickNodeWidth';
import StickOnHover from './StickOnHover';
import StyledWithDataAttributes from './StyledWithDataAttributes';
import TransportToFixedContainer from './TransportToFixedContainer';
export default function Regressions() {
    return (_jsxs("div", { children: [_jsx("h1", { children: "Regressions" }), _jsx(ButtonOverlay, {}), _jsx(SameWidth, {}), _jsx(StickNodeWidth, {}), _jsx(FitOnPage, {}), _jsx(StickInSvg, {}), _jsx(StyledWithDataAttributes, {}), _jsx(TransportToFixedContainer, {}), _jsx(StickOnHover, {}), _jsx(ScrollPosition, {})] }));
}
